module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/ko_hokkaido-a6447399d1bce9f2e9bbc99576f10e01.jpg";